import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ProjectQueriesTags } from "../../api/project";
import { findCompanyByInnKpp } from "../@x/company";
import { addParticipant } from "../api/add-participant";

type AddCompanyParty = {
  inn: string;
  kpp: string;
};

export function useAddCompanyToProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      company,
      projectId,
    }: {
      company: AddCompanyParty;
      projectId: string;
    }) => {
      const companyServiceData = await findCompanyByInnKpp({
        inn: company.inn,
        kpp: company.kpp,
      });

      return addParticipant({
        projectId,
        body: {
          companyId: companyServiceData.companyId,
        },
      });
    },
    onSuccess: (_data, { projectId }) => {
      queryClient
        .invalidateQueries({
          queryKey: ProjectQueriesTags.getProjectParticipants({
            projectId: projectId ?? "",
          }),
        })
        .then();
    },
  });
}
